// FETCH ALL PRODUCT
export const FETCH_PRODUCT_MASTER_REQUEST = 'FETCH_PRODUCT_MASTER_REQUEST';
export const FETCH_PRODUCT_MASTER_SUCCESS = 'FETCH_PRODUCT_MASTER_SUCCESS';
export const FETCH_PRODUCT_MASTER_FAILURE = 'FETCH_PRODUCT_MASTER_FAILURE';

// CREATE PRODUCT
export const CREATE_PRODUCT_MASTER_REQUEST = 'CREATE_PRODUCT_MASTER_REQUEST';
export const CREATE_PRODUCT_MASTER_SUCCESS = 'CREATE_PRODUCT_MASTER_SUCCESS';
export const CREATE_PRODUCT_MASTER_FAILURE = 'CREATE_PRODUCT_MASTER_FAILURE';

// UPDATE PRODUCT
export const UPDATE_PRODUCT_MASTER_REQUEST = 'UPDATE_PRODUCT_MASTER_REQUEST';
export const UPDATE_PRODUCT_MASTER_SUCCESS = 'UPDATE_PRODUCT_MASTER_SUCCESS';
export const UPDATE_PRODUCT_MASTER_FAILURE = 'UPDATE_PRODUCT_MASTER_FAILURE';

// FETCH SINGLE STATE OF PRODUCT
export const FETCH_SINGLE_PRODUCT_MASTER_REQUEST = 'FETCH_SINGLE_PRODUCT_MASTER_REQUEST';
export const FETCH_SINGLE_PRODUCT_MASTER_SUCCESS = 'FETCH_SINGLE_PRODUCT_MASTER_SUCCESS';
export const FETCH_SINGLE_PRODUCT_MASTER_FAILURE = 'FETCH_SINGLE_PRODUCT_MASTER_FAILURE';

// DELETE PRODUCT
export const DELETE_PRODUCT_MASTER_REQUEST = 'DELETE_PRODUCT_MASTER_REQUEST';
export const DELETE_PRODUCT_MASTER_SUCCESS = 'DELETE_PRODUCT_MASTER_SUCCESS';
export const DELETE_PRODUCT_MASTER_FAILURE = 'DELETE_PRODUCT_MASTER_FAILURE';

// FETCH PROPERTY
export const FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_REQUEST = 'FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_REQUEST';
export const FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS = 'FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_SUCCESS';
export const FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_FAILURE = 'FETCH_PROPERTY_DATA_FOR_PRODUCT_MASTER_FAILURE';

export const RESET_PRODUCT_MASTER_INFO = 'RESET_PRODUCT_MASTER_INFO';

export const CREATE_PRODUCT_MASTER_FORM = 'CREATE_PRODUCT_MASTER_FORM';

export const UPDATE_PRODUCT_MASTER_FORM = 'UPDATE_PRODUCT_MASTER_FORM';


// NAVIGATE TO PRODUCT DETAILS COMPONENT
export const NAVIGATE_PRODUCT_DETAILS = 'NAVIGATE_PRODUCT_DETAILS';

// NAVIGATE TO PRODUCT COMPONENT
export const NAVIGATE_PRODUCT_MASTER = 'NAVIGATE_PRODUCT_MASTER';